import * as Sentry from "@sentry/nextjs";

if (process.env.NODE_ENV === "production")
    Sentry.init({
        dsn: "https://ad5517ac4cd5f3705b18150b45202128@o4505392412884992.ingest.us.sentry.io/4505683863797760",

        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        // Replay may only be enabled for the client-side
        // Note: if you want to override the automatic release value, do not set a
        // `release` value here - use the environment variable `SENTRY_RELEASE`, so
        // that it will also get attached to your source maps
    });

// This export will instrument router navigations, and is only relevant if you enable tracing.
// `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
